/**
 * Environment Slice
 *
 * Manages region, stage, apiBase, and theme state.
 * Changing region or stage automatically recalculates the API base URL.
 *
 * Actions:
 *   setRegion(regionId)  — user selects a region in the header dropdown
 *   setStage(stageName)  — rarely used (stage is auto-detected from URL)
 *   toggleTheme()        — switches between light and dark mode
 *   reset()              — restores all env state to defaults (e.g. on signout)
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isGlobalRegion } from '../../../constants';
import { envInitialState, resolveApiBase } from './envState';

const envSlice = createSlice({
  name: 'env',
  initialState: envInitialState,
  reducers: {
    setRegion: (state, action: PayloadAction<string>) => {
      state.region = action.payload;
      state.apiBase = resolveApiBase(state.stage, action.payload);
      state.global = isGlobalRegion(action.payload);
    },
    setStage: (state, action: PayloadAction<string>) => {
      state.stage = action.payload;
      state.apiBase = resolveApiBase(action.payload, state.region);
    },
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
    },
    reset: () => envInitialState,
  },
});

export const { setRegion, setStage, toggleTheme, reset } = envSlice.actions;
export default envSlice.reducer;
